import React, { useEffect, useState } from "react";
import DataTable from "../datatable/DataTable";
import Button from "../global/Button";
import FullDateFormat from "../global/FullDateFormat";
import HeaderNav from "../global/HeaderNav";
import Loader from "../global/Loader";
import TextInput from "../global/TextInput";
import { payments } from "../../constants/data";
import CurrencyFormatter from "../global/CurrencyFormatter";
import DateTimeFormat from "../global/DateTimeFormat";
import { paymentStatus } from "../global/PaymentStatus";

function PaymentsReport() {
  const [inputValues, setInputValues] = useState({
    start_date: "",
    end_date: "",
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [loadedData, setLoadedData] = useState(null);

  //   handle field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  let loadData = () => {
    setLoadedData(payments);
    setIsSubmit(false);
  };

  useEffect(() => {
    handleSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValues]);

  //submit the form
  const handleSubmit = () => {
    setIsSubmit(true);

    if (
      inputValues.start_date !== "" &&
      inputValues.end_date !== "" &&
      isSubmit
    ) {
      loadData();
    }
  };

  const headers = [
    "Payment ID",
    "Amount",
    "Payment date",
    "Paid to",
    "Paybill number",
    "Paid by",
    "Account number",
    "Status",
    "Statement",
  ];
  let tableRows = [];

  if (loadedData?.length) {
    for (let i = 0; i < loadedData?.length; i++) {
      tableRows.push({
        payment_id: payments[i].payment_id,
        amount: <CurrencyFormatter value={payments[i].amount} />,
        created_at: <DateTimeFormat>{payments[i].created_at}</DateTimeFormat>,
        paid_to: payments[i].bank_name,
        paybill_number: payments[i].bank_id,
        paid_by: payments[i].client,
        payer_id: payments[i].account_number,
        status: paymentStatus(payments[i].status),
        more: (
          <i
            className="bx bx-printer links text-[16px] cursor-pointer"
            onClick={() => printStatement(loadedData[i])}
          ></i>
        ),
      });
    }
  }

  const printStatement = (id) => {
    console.log(id);
  };

  const displayContent = isSubmit ? (
    <Loader />
  ) : loadedData ? (
    <DataTable headers={headers} data={tableRows} />
  ) : (
    ""
  );

  let exportPDF = () => {
    console.log("Export PDF");
  };

  return (
    <div>
      {/* display header */}
      <HeaderNav title="Payments report" />

      {/* filters */}
      <div className="flex justify-center space-x-6">
        <div className="flex space-x-4 flex-row items-center">
          <TextInput
            required="required"
            label="From"
            name="start_date"
            type="date"
            value={inputValues.start_date}
            onChange={handleChange}
          />
        </div>
        <div className="flex space-x-4 flex-row items-center">
          <TextInput
            required="required"
            label="To"
            name="end_date"
            type="date"
            value={inputValues.end_date}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* summary */}
      {loadedData ? (
        <div className="flex flex-row sm:flex-col sm:space-y-2 justify-between items-center m-4">
          <div className="text-xs text-gray-600">
            <FullDateFormat>{inputValues.start_date}</FullDateFormat> &ensp; -
            &ensp; <FullDateFormat>{inputValues.end_date}</FullDateFormat>
          </div>
          <Button
            onClick={exportPDF}
            text="Export PDF"
            bgColor={"bg-primary"}
          />
        </div>
      ) : (
        ""
      )}
      {/* display the totals */}
      {loadedData ? (
        <div className="flex items-center justify-end w-full my-4">
          <div className=" border border-gray-200 h-16 w-max flex-col p-4 mr-2 rounded-md shadow-md">
            <p className="text-end text-xs text-gray-500">
              Total Volumes traded
            </p>
            <span className="font-bold text-gray-500">
              {<CurrencyFormatter value={20500} />}
            </span>
          </div>
          <div className=" border border-gray-200 h-16 w-max flex-col p-4 mr-2 rounded-md shadow-md">
            <p className="text-end text-xs text-gray-500">Total commissions</p>
            <span className="font-bold text-gray-500">
              {<CurrencyFormatter value={2500} />}
            </span>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* display contents */}
      {displayContent}
    </div>
  );
}

export default PaymentsReport;
